import { logWarn } from '../logger';
import isValidLocale from '../validateLocale/validateLocale';
import { getFallbackRegion } from './getFallbackRegion';
import { regionMapping } from './regionMapping';
export const getRegionFromLocale = (locale) => {
    // To support accidental typos in data-locale attribute
    if (locale) {
        locale = locale.replace('_', '-');
    }
    if (locale && isValidLocale(locale)) {
        const countryCode = locale.split('-')[1].toLowerCase();
        if (countryCode in regionMapping) {
            return regionMapping[countryCode];
        }
    }
    const fallbackRegion = getFallbackRegion();
    logWarn(`Provided locale is not supported - defaulting region to ${fallbackRegion}`);
    return fallbackRegion;
};
